module.exports = __webpack_public_path__ + "static/shape1-2703801579c52c71e481d8f2605a9bbe.svg";